import { render, staticRenderFns } from "./GeschaeftspartnerAdresse.vue?vue&type=template&id=38a9e739"
import script from "./GeschaeftspartnerAdresse.vue?vue&type=script&lang=js"
export * from "./GeschaeftspartnerAdresse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports